/**
 * Onboarding step configuration.
 *
 * Internal keys still include `locations` (collected on company-info) and
 * `insurance` (shown with Stripe on the last page) so saved step indexes stay
 * stable. The wizard skips those keys when navigating.
 */
export const ONBOARDING_STEP_KEYS = [
    "company-info",
    "locations",
    "categories",
    "add-car",
    "stripe",
    "insurance",
    // Appended rather than inserted so every existing saved index keeps pointing at the same
    // step. Preferences comes last because some of its toggles (full payment required) only
    // make sense once Stripe is connected on the step before.
    "preferences",
];

export const ONBOARDING_STEP_KEY_TO_INDEX = Object.fromEntries(
    ONBOARDING_STEP_KEYS.map((key, index) => [key, index]),
);

/** Keys kept for backend indexes but not shown as their own wizard pages. */
export const HIDDEN_ONBOARDING_STEP_KEYS = ["locations", "insurance"];

/** Legacy URL slugs → current step key */
export const ONBOARDING_LEGACY_STEP_REDIRECTS = {
    "company-info": "company-info",
    "list-vehicle": "add-car",
    // Previously redirected to "categories" because the preferences step did not exist. The
    // backend had always tracked `stepStatus.preferences`, so the step was reachable by URL,
    // silently bounced elsewhere, and could never be completed.
    preferences: "preferences",
    categories: "categories",
    locations: "company-info",
    "add-car": "add-car",
    stripe: "stripe",
    insurance: "stripe",
};

export const resolveOnboardingStepKey = (stepParam) => {
    if (!stepParam) {
        return ONBOARDING_STEP_KEYS[0];
    }

    const legacyTarget = ONBOARDING_LEGACY_STEP_REDIRECTS[stepParam];
    if (legacyTarget && ONBOARDING_STEP_KEY_TO_INDEX[legacyTarget] !== undefined) {
        return legacyTarget;
    }

    if (ONBOARDING_STEP_KEY_TO_INDEX[stepParam] !== undefined) {
        return stepParam;
    }

    return ONBOARDING_STEP_KEYS[0];
};

export const isOnboardingUrlStepResolved = (stepParam) => {
    if (!stepParam) {
        return false;
    }
    return stepParam === resolveOnboardingStepKey(stepParam);
};
